import { render } from "./PanelBox.vue?vue&type=template&id=414603f2&scoped=true"
import script from "./PanelBox.vue?vue&type=script&lang=js"
export * from "./PanelBox.vue?vue&type=script&lang=js"

import "./PanelBox.vue?vue&type=style&index=0&id=414603f2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-414603f2"]])

export default __exports__